// extracted by mini-css-extract-plugin
export var cardOdd = "card-module--cardOdd--vv0ko";
export var cardText = "card-module--cardText--YZMG3";
export var cardEven = "card-module--cardEven--ZVxOU";